import { useState } from 'react';
import { InvoiceDialog } from './InvoiceDialog';
import { useStripeInvoiceQuery } from '../../graphql/react-operations';
import { LoadingDialog } from '../simple-dialogs/LoadingDialog/LoadingDialog';
import { isNil } from 'lodash-es';
import { PaymentDialog } from './PaymentDialog';

interface Props {
  companyId: string;
  invoiceId: string;
  onCancel: () => void;
  onPaid: () => void;
}

export const Invoice = ({ companyId, invoiceId, onCancel, onPaid }: Props) => {
  const { loading, data, error, refetch } = useStripeInvoiceQuery({ variables: { companyId, invoiceId } });
  const [attemptedPayment, setAttemptedPayment] = useState(false);
  if (loading) {
    return <LoadingDialog />;
  }
  if (!isNil(error) || !data) {
    // Handle error
    return null;
  }

  const handleOnPaid = async () => {
    setAttemptedPayment(true);
    await refetch();
  };

  const invoice = data.stripeInvoice;
  if (invoice.status === 'paid') {
    onPaid();
    return null;
  }
  if (!attemptedPayment) {
    return <InvoiceDialog onPaid={() => handleOnPaid()} {...{ companyId, onCancel, invoice }} />;
  }
  return <PaymentDialog paymentIntentId={invoice.payment_intent} {...{ companyId, onCancel, onPaid }} />;
};
